exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Groups{\r\n    overflow: hidden;\r\n    padding-top: 40vh;\r\n    transition: all .4s ease-in-out;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n}\r\n\r\n\r\n\r\n@media all and (orientation:landscape) {\r\n    .Groups{\r\n        height: 100vh;\r\n        padding-top: 0;\r\n    }\r\n}", ""]);

// exports
